export type CmsErrorPageStatus = '404' | '500'

export function getCmsErrorPageStatus(errorCode?: string): CmsErrorPageStatus {
  return errorCode === 'NOT_FOUND' ? '404' : '500'
}
